module.exports = __webpack_public_path__ + "static/media/transportation-category.d6e465f4.png";